<!-- 【画面名】投票企画終了 -->

<template>
  <CommonHeader />
  <div id="entry-terminate" class="entry-terminate">

    <div class="content">
      <div class="message-area">
        <p class="full-text" v-if="fullText" v-html='fullText'></p>

        <p class="incentive-text" v-if="incentiveFlag">
          <span class="incentive-text-before" v-if="incentiveLinkFrontText" v-html='incentiveLinkFrontText'></span>
          <a class="fixed-link-text" v-if="incentiveLinkName" v-html='incentiveLinkName' v-bind:href="incentiveLinkUrl"></a>
          <span class="incentive-text-after" v-if="incentiveLinkRearText" v-html='incentiveLinkRearText'></span>
        </p>

        <p class="bottom-text">
          <span class="bottom-text-before" v-if="frontLinkText" v-html='frontLinkText'></span>
          <a class="fixed-link-text" v-if="linkName" v-html='linkName' v-bind:href="linkUrl"></a>
          <span class="bottom-text-after" v-if="rearLinkText" v-html='rearLinkText'></span>
        </p>

      </div>

      <div class="foot-text" v-if="bottomText" v-html='bottomText'></div>
    </div>
    <!-- /.content -->

  </div>
  <CommonFooter />
</template>

<script>
/* eslint-disable */
import CommonHeader from './CommonHeader.vue'
import CommonFooter from './CommonFooter.vue'
import axios from 'axios';

export default {
  name: 'CompleteSession',
  components: {
    CommonHeader,
    CommonFooter,
  },
  data() {
    return {
      incentiveInfo: [],
      basicInfo: [],
      fullText: '',
      frontLinkText: '',
      linkName: '',
      linkUrl: '',
      rearLinkText: '',
      bottomText: '',
      fileCreatedAt: '',
      urlKey: '',
      salt: '',
      incDir: '',
      incentiveFlag: false,
      incentiveLinkFrontText: '',
      incentiveLinkName: '',
      incentiveLinkRearText: '',
      incentiveLinkUrl: '',
    }
  },
  inject: ['voteScreanInfo', 'encryptSha256', 'getUrlKey', 'getReservedWord'],
  mounted(){ // ページが読み込まれたらする処理
    // console.log(this.providedData[0].basic_info);
    var displayInfo = this.voteScreanInfo[0].display_info;
    var completeInformation = displayInfo.complete_information;
    this.basicInfo = this.voteScreanInfo[0].basic_info;
    this.fileCreatedAt = this.voteScreanInfo[0].file_created_at; // 投票画面情報ファイル生成日時
    this.salt = process.env.VUE_APP_VOTE_SCREEN_HASH_SALT

    if(!completeInformation) return false;

    // 上部下部テキスト設置
    this.fullText = this.getReservedWord(completeInformation.cs_full_text);
    this.frontLinkText = completeInformation.cs_front_link_text;
    this.linkName = completeInformation.cs_link_name;
    this.linkUrl = completeInformation.cs_link_url;
    this.rearLinkText = completeInformation.cs_rear_link_text;
    this.bottomText = this.getReservedWord(completeInformation.cs_bottom_text);

    // クイズ形式
    if(this.basicInfo.mode != 2) return;

    this.urlKey = this.getUrlKey(); // URLキー
    // 番組枠ID ＋ URLキー ＋ 投票画面情報ファイル生成日時 ＋ ソルト(固定文字列)
    var incHashKey = this.basicInfo.program_frame_id + this.urlKey + this.fileCreatedAt + this.salt;
    this.incDir = this.encryptSha256(incHashKey).toString();
    // console.log(incHashKey);
    // console.log(this.incDir);

    // インセンティブ情報取得
    this.getIncentive();
    
  },
  methods: { // 使い回す関数

    getIncentive() { // インセンティブ情報ファイル取得

      var host = location.host;
      var locPathname = location.pathname;
      var pathname = locPathname.substring(0, locPathname.lastIndexOf('/')) + '/';
      if(host.indexOf('localhost') > -1) {
        var jsonPath = './'+this.incDir+'/vote_incentive.json';
      } else {
        var jsonPath = pathname + this.incDir + '/vote_incentive.json';
      }

      // console.log('インセンティブファイルパス');
      // console.log(jsonPath);

      axios
      .get(jsonPath)
      .then(
        response => {
          // console.log(response);
          this.incentiveInfo.push(response.data);

          this.viewIncentive();
        }
      )
      .catch(
        error => {
          console.log('Axios Error');
          console.log(error);
        }
      )
      .finally();
    },

    viewIncentive() { // インセンティブ情報表示

      var programCookieKey ='nhk_'+ this.basicInfo.program_frame_id + '_' + this.basicInfo.program_id;
      var cookieData = this.$cookies.get(programCookieKey);
      var score = 0;

      // ユーザーのスコアを集計
      if(cookieData) {
        if(cookieData.answers && Array.isArray(cookieData.answers) ) {
          var answers = cookieData.answers;

          if(this.incentiveInfo[0].cs_incentive_criteria == 1) {
            // 得点数
            for(const answer of answers) {
              if(answer.res == 1) {
                score = score + answer.score;
              }
            }
          } else if(this.incentiveInfo[0].cs_incentive_criteria == 2) {
            // 正解回答数
            for(const answer of answers) {
              if(answer.res == 1) {
                score++;
              }
            }
          } else if(this.incentiveInfo[0].cs_incentive_criteria == 3) {
            // 回答数
            score = answers.length;
          }

        }
      }

      if(this.incentiveInfo.length) {

        var clearBorderNum = 0;
        for(const [key, value] of Object.entries(this.incentiveInfo[0].cs_boundary_value_list)) {
          if(score >= value.cs_incentive_border_val) {
            clearBorderNum = key;
            this.incentiveFlag = true;
          } 
        }
        var outputInc = this.incentiveInfo[0].cs_boundary_value_list[clearBorderNum];
        this.incentiveLinkFrontText = outputInc.cs_incentive_link_front_text;
        this.incentiveLinkName = outputInc.cs_incentive_link_name;
        this.incentiveLinkRearText = outputInc.cs_incentive_link_rear_text;
        this.incentiveLinkUrl = outputInc.cs_incentive_link_url;
      }
    },

  },
}
/* eslint-disable */
</script>
